import React, { useState } from "react";
import { Card } from "react-bootstrap";
import "./ContactCard.css";
import ChangePhoneNumber from "../Common_profile_details_modals/ChangePhoneNumber/ChangePhoneNumber";
import VerifyPhoneNumberModal from "../Common_profile_details_modals/VerifyPhoneNumberModal/VerifyPhoneNumberModal";

const ContactCard = () => {
  const [showPhoneModal, setShowPhoneModal] = useState(false);
  const [showVerifyModal, setShowVerifyModal] = useState(false);

  const openPhoneModal = () => {
    setShowVerifyModal(false); // Close Verify Modal
    setShowPhoneModal(true); // Open Change Phone Modal
  };

  const closePhoneModal = () => {
    setShowPhoneModal(false);
  };

  const openVerifyModal = () => {
    setShowPhoneModal(false);
    setShowVerifyModal(true);
  };

  const closeVerifyModal = () => {
    setShowVerifyModal(false);
  };
  return (
    <>
      <Card className="contact-card">
        <Card.Body>
          <div
            className="contact-card__item"
            onClick={openPhoneModal}
            style={{ cursor: "pointer" }}
          >
            <span className="contact-card__icon">📞</span>
            <span className="contact-card__text">+91 8329717621</span>
            <span className="summary-card__edit-icon">✏️</span>
          </div>

          {/* Email */}
          <div className="contact-card__item">
            <span className="contact-card__icon">✉️</span>
            <span className="contact-card__text">smitalad055@gmail.com</span>
          </div>
        </Card.Body>
      </Card>

      <ChangePhoneNumber
        show={showPhoneModal}
        handleClose={closePhoneModal}
        openVerifyModal={openVerifyModal}
      />

      <VerifyPhoneNumberModal
        show={showVerifyModal}
        handleClose={closeVerifyModal}
        openPhoneModal={openPhoneModal}
      />
    </>
  );
};

export default ContactCard;
